












import Vue from 'vue';
import SideBar from '@/parts/about/SideBar.vue';
import ReturnTop from "@/parts/util/ReturnTop.vue";

export default Vue.extend({
  name: 'Guide',
  components: {
    SideBar,
    ReturnTop,
  },
})
